import { useEffect } from 'react'

import { useUserId } from '@acorns/web-utils'
import { datadogRum } from '@datadog/browser-rum'

export const DatadogUserId = () => {
  const { userId } = useUserId()

  useEffect(() => {
    if (userId !== 'no_user_id') {
      datadogRum.setGlobalContext({ userid: userId })
    }
  }, [userId])

  return null
}
